import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_PATIENTORDER_INIT_ACTION,
  FETCH_PATIENTORDER_SUCCESS_ACTION,
  FETCH_PATIENTORDER_FAIL_ACTION,
} from "./action";
import { appConfig } from "../../config";
import "react-toastify/dist/ReactToastify.css";

function* fetchPatientOrder(value) {
  const token = localStorage.getItem("token");
  let pageno = !value.value
    ? 1
    : value.value.page === undefined
    ? 1
    : value.value.page;
  let searchquery = !value.value
    ? ""
    : value.value.searchquery === ""
    ? ""
    : value.value.searchquery;
  let status = !value.value
    ? ""
    : value.value.filter === ""
    ? ""
    : value.value.filter;
  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orgType=patient&orderType=purchase&search=${searchquery}&status=${status}&limit=10&page=${pageno}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_PATIENTORDER_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_PATIENTORDER_FAIL_ACTION, error: err });
    } else {
    }
  }
}

export function* PatientsOrderActionWatcher() {
  yield takeEvery(FETCH_PATIENTORDER_INIT_ACTION, fetchPatientOrder);
}
